import React from 'react';
import './Projects.css';

const ArcFinanceHubLogo = () => (
  <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <defs>
      <linearGradient id="afh-grad" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#8B5CFF" />
        <stop offset="55%" stopColor="#22E0FF" />
        <stop offset="100%" stopColor="#7CFFB2" />
      </linearGradient>
    </defs>
    <rect x="0" y="0" width="32" height="32" rx="7" fill="#0B0F1A" />
    <path
      d="M5 23 L16 5 L27 23 Z"
      fill="none"
      stroke="url(#afh-grad)"
      strokeWidth="2.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="16" cy="17" r="2.6" fill="url(#afh-grad)" />
  </svg>
);

const FastysendLogo = () => (
  <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <defs>
      <linearGradient id="fs-grad" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#8B5CFF" />
        <stop offset="60%" stopColor="#22E0FF" />
        <stop offset="100%" stopColor="#7CFFB2" />
      </linearGradient>
    </defs>
    <rect x="0" y="0" width="64" height="64" rx="14" fill="#0E1424" />
    <path
      d="M14 20 L30 32 L14 44"
      stroke="url(#fs-grad)"
      strokeWidth="5"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      opacity="0.55"
    />
    <path
      className="fs-chevron"
      d="M28 20 L44 32 L28 44"
      stroke="url(#fs-grad)"
      strokeWidth="5"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle className="fs-dot" cx="50" cy="32" r="4" fill="#7CFFB2" />
  </svg>
);

const MicrosubLogo = () => (
  <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <defs>
      <linearGradient id="ms-bg" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#5EEAD4" />
        <stop offset="100%" stopColor="#A78BFA" />
      </linearGradient>
      <radialGradient id="ms-core" cx="0.5" cy="0.5" r="0.5">
        <stop offset="0%" stopColor="#5EEAD4" />
        <stop offset="100%" stopColor="#A78BFA" />
      </radialGradient>
    </defs>
    <rect x="0" y="0" width="64" height="64" rx="14" fill="#0B0F1A" />
    <circle className="ms-ring ms-r-outer" cx="32" cy="32" r="25" fill="none" stroke="url(#ms-bg)" strokeWidth="1.6" opacity="0.22" />
    <circle className="ms-ring ms-r-mid"   cx="32" cy="32" r="18" fill="none" stroke="url(#ms-bg)" strokeWidth="2"   opacity="0.5" />
    <circle className="ms-ring ms-r-core"  cx="32" cy="32" r="11" fill="none" stroke="url(#ms-bg)" strokeWidth="2.4" opacity="0.85" />
    <circle cx="32" cy="32" r="5.5" fill="url(#ms-core)" />
  </svg>
);

const AidrivexLogo = () => (
  <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <defs>
      <linearGradient id="ax-grad" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#7C3AED" />
        <stop offset="100%" stopColor="#22D3EE" />
      </linearGradient>
    </defs>
    <rect x="0" y="0" width="64" height="64" rx="14" fill="#0B0F1A" />
    <circle cx="32" cy="32" r="20" fill="none" stroke="url(#ax-grad)" strokeWidth="3" opacity="0.4" />
    <text
      x="32"
      y="40"
      fontFamily="Arial, sans-serif"
      fontSize="26"
      fontWeight="700"
      fill="url(#ax-grad)"
      textAnchor="middle"
    >Ax</text>
  </svg>
);

const ArcSplitItLogo = () => (
  <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <defs>
      <linearGradient id="asi-grad" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#2775CA" />
        <stop offset="1" stopColor="#7CFFB2" />
      </linearGradient>
    </defs>
    <rect x="0" y="0" width="32" height="32" rx="7" fill="#050810" />
    <rect x="3" y="6" width="26" height="20" rx="4" fill="none" stroke="url(#asi-grad)" strokeWidth="2.4" />
    <path d="M11 16h10" stroke="url(#asi-grad)" strokeWidth="2.4" strokeLinecap="round" />
    <path d="M16 11v10" stroke="url(#asi-grad)" strokeWidth="2.4" strokeLinecap="round" />
  </svg>
);

const ArcYieldLogo = () => (
  <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <defs>
      <linearGradient id="ay-grad" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#00C2A8" />
        <stop offset="0.55" stopColor="#22E0FF" />
        <stop offset="1" stopColor="#7CFFB2" />
      </linearGradient>
    </defs>
    <rect x="0" y="0" width="32" height="32" rx="7" fill="#04060E" />
    <path d="M4 22 Q10 8 16 16 T28 10" fill="none" stroke="url(#ay-grad)" strokeWidth="3" strokeLinecap="round" />
    <circle cx="25" cy="12" r="2.6" fill="#7CFFB2" />
  </svg>
);

const ArcPayrollLogo = () => (
  <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <defs>
      <linearGradient id="apr-grad" x1="0" y1="0" x2="32" y2="32" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#8B5CFF" />
        <stop offset="0.55" stopColor="#22E0FF" />
        <stop offset="1" stopColor="#7CFFB2" />
      </linearGradient>
    </defs>
    <rect x="0" y="0" width="32" height="32" rx="7" fill="#0B0F1A" />
    <g fill="none" stroke="url(#apr-grad)" strokeWidth="2.2" strokeLinecap="round">
      <path d="M7 12 H22" />
      <path d="M7 16 H19" />
      <path d="M7 20 H16" />
    </g>
    <g fill="none" stroke="url(#apr-grad)" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 12 L26 16 L22 20" />
    </g>
  </svg>
);

const ArcAutoPayLogo = () => (
  <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <defs>
      <linearGradient id="aap-grad" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#8B5CFF" />
        <stop offset="0.55" stopColor="#22E0FF" />
        <stop offset="1" stopColor="#7CFFB2" />
      </linearGradient>
    </defs>
    <rect width="32" height="32" rx="9" fill="#0A0D1C" stroke="url(#aap-grad)" strokeWidth="1.5" />
    <path d="M24 16 A8 8 0 1 1 17.5 8.2" fill="none" stroke="url(#aap-grad)" strokeWidth="2.4" strokeLinecap="round" />
    <path d="M24 7.5 L24 12 L19.5 12" fill="none" stroke="url(#aap-grad)" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const IcxLogo = () => (
  <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <defs>
      <linearGradient id="icx-grad" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#00d4ff" />
        <stop offset="1" stopColor="#6366f1" />
      </linearGradient>
    </defs>
    <rect x="0" y="0" width="32" height="32" rx="7" fill="#0a0a0a" />
    <circle cx="16" cy="16" r="14" fill="none" stroke="url(#icx-grad)" strokeWidth="2" />
    <path d="M18 8 L10 18 L15 18 L14 24 L22 14 L17 14 Z" fill="url(#icx-grad)" />
  </svg>
);

const ArcEscrowLogo = () => (
  <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <defs>
      <linearGradient id="ae-grad" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#5ec5ff" />
        <stop offset="50%" stopColor="#7a8cff" />
        <stop offset="100%" stopColor="#ff5ec8" />
      </linearGradient>
    </defs>
    <rect x="0" y="0" width="36" height="36" rx="8" fill="#07090f" />
    <path
      d="M18 5 L29 10 L29 19 C29 24.5 24 29 18 30.5 C12 29 7 24.5 7 19 L7 10 Z"
      fill="none"
      stroke="url(#ae-grad)"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 23 L18 12 L23 23 M14.8 19 H21.2"
      fill="none"
      stroke="url(#ae-grad)"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const PeopletagLogo = () => (
  <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <circle cx="50" cy="50" r="48" fill="#4a90e2" />
    <text
      x="50"
      y="72"
      fontFamily="Arial, sans-serif"
      fontSize="70"
      fontWeight="bold"
      fill="white"
      textAnchor="middle"
    >#</text>
  </svg>
);

const LakeyLogo = () => (
  <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" fill="none" aria-hidden="true">
    <defs>
      <linearGradient id="lk-bg" x1="4" y1="4" x2="44" y2="44" gradientUnits="userSpaceOnUse">
        <stop stopColor="#6ea8ff" />
        <stop offset="0.55" stopColor="#5b7fff" />
        <stop offset="1" stopColor="#8b5cf6" />
      </linearGradient>
      <linearGradient id="lk-shine" x1="6" y1="2" x2="26" y2="30" gradientUnits="userSpaceOnUse">
        <stop stopColor="#fff" stopOpacity="0.32" />
        <stop offset="1" stopColor="#fff" stopOpacity="0" />
      </linearGradient>
    </defs>
    <rect x="2" y="2" width="44" height="44" rx="13.5" fill="url(#lk-bg)" />
    <rect x="2" y="2" width="44" height="44" rx="13.5" fill="url(#lk-shine)" />
    <path d="M16.5 13v13.7a6.8 6.8 0 0 0 6.8 6.8h8.2" stroke="#fff" strokeWidth="5.2" strokeLinecap="round" fill="none" />
    <path d="M33.6 10.8c1.05 3.45 1.75 4.15 5.2 5.2-3.45 1.05-4.15 1.75-5.2 5.2-1.05-3.45-1.75-4.15-5.2-5.2 3.45-1.05 4.15-1.75 5.2-5.2z" fill="#e2ff70" />
  </svg>
);

const LakeyFitLogo = () => (
  <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" fill="none" aria-hidden="true">
    <defs>
      <linearGradient id="lkf-bg" x1="4" y1="4" x2="44" y2="44" gradientUnits="userSpaceOnUse">
        <stop stopColor="#4ce39a" />
        <stop offset="0.55" stopColor="#22c98b" />
        <stop offset="1" stopColor="#0ea5e9" />
      </linearGradient>
      <linearGradient id="lkf-shine" x1="6" y1="2" x2="26" y2="30" gradientUnits="userSpaceOnUse">
        <stop stopColor="#fff" stopOpacity="0.34" />
        <stop offset="1" stopColor="#fff" stopOpacity="0" />
      </linearGradient>
    </defs>
    <rect x="2" y="2" width="44" height="44" rx="13.5" fill="url(#lkf-bg)" />
    <rect x="2" y="2" width="44" height="44" rx="13.5" fill="url(#lkf-shine)" />
    <path d="M15.5 13v13.7a6.8 6.8 0 0 0 6.8 6.8h8.2" stroke="#fff" strokeWidth="5.2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    <g stroke="#eaff7a" strokeWidth="2.6" strokeLinecap="round">
      <path d="M29 14.6v6.4" />
      <path d="M26.2 13.4h5.6" />
      <path d="M26.2 22.2h5.6" />
    </g>
  </svg>
);

const LakeyLookLogo = () => (
  <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" fill="none" aria-hidden="true">
    <defs>
      <linearGradient id="lkl-bg" x1="4" y1="3" x2="45" y2="46" gradientUnits="userSpaceOnUse">
        <stop stopColor="#24251f" />
        <stop offset="1" stopColor="#0b0b09" />
      </linearGradient>
    </defs>
    <rect x="2" y="2" width="44" height="44" rx="13.5" fill="url(#lkl-bg)" />
    <rect x="2.7" y="2.7" width="42.6" height="42.6" rx="12.8" stroke="#d9ff59" strokeOpacity="0.32" strokeWidth="1.4" />
    <path d="M14.5 11.5v16.4c0 4.9 3.9 8.8 8.8 8.8h10.3" stroke="#fffef8" strokeWidth="5.2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M22.8 19.4c2.25-3 5.1-4.5 8.55-4.5 3.42 0 6.25 1.5 8.48 4.5-2.23 3-5.06 4.5-8.48 4.5-3.45 0-6.3-1.5-8.55-4.5Z" fill="#d9ff59" />
    <circle cx="31.35" cy="19.4" r="2.9" fill="#12120f" />
    <circle cx="32.3" cy="18.45" r="0.75" fill="#fffef8" />
  </svg>
);

const LakeyNoWordsLogo = () => (
  <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" fill="none" aria-hidden="true">
    <defs>
      <linearGradient id="lkn-bg" x1="4" y1="2" x2="44" y2="46" gradientUnits="userSpaceOnUse">
        <stop stopColor="#b18cff" />
        <stop offset="0.52" stopColor="#7c5cff" />
        <stop offset="1" stopColor="#4338ca" />
      </linearGradient>
    </defs>
    <rect x="2" y="2" width="44" height="44" rx="13.5" fill="url(#lkn-bg)" />
    <path d="M11.5 17.4a4.4 4.4 0 0 1 4.4-4.4h16.2a4.4 4.4 0 0 1 4.4 4.4v8.4a4.4 4.4 0 0 1-4.4 4.4H21.3l-5.6 5.1a.7.7 0 0 1-1.2-.52V30.2h-2a1.1 1.1 0 0 1-1-1.1z" fill="#fff" />
    <g fill="#f5b455">
      <circle cx="17.6" cy="21.6" r="2" />
      <circle cx="24" cy="21.6" r="2" />
      <circle cx="30.4" cy="21.6" r="2" />
    </g>
  </svg>
);

const FujoAiLogo = () => (
  <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" fill="none" aria-hidden="true">
    <defs>
      <linearGradient id="fj-bg" x1="4" y1="4" x2="44" y2="44" gradientUnits="userSpaceOnUse">
        <stop stopColor="#ff8a3d" />
        <stop offset="0.55" stopColor="#f43f5e" />
        <stop offset="1" stopColor="#8b5cf6" />
      </linearGradient>
    </defs>
    <rect x="2" y="2" width="44" height="44" rx="13.5" fill="url(#fj-bg)" />
    <path d="M26 9 L15 26 h8 l-3 13 12-18h-8z" fill="#fff" />
    <circle cx="35.5" cy="12.5" r="3.2" fill="#ffe27a" />
  </svg>
);

const LakeyTravelLogo = () => (
  <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" fill="none" aria-hidden="true">
    <defs>
      <linearGradient id="lkt-bg" x1="4" y1="4" x2="44" y2="44" gradientUnits="userSpaceOnUse">
        <stop stopColor="#22d3ee" />
        <stop offset="0.55" stopColor="#3b82f6" />
        <stop offset="1" stopColor="#a855f7" />
      </linearGradient>
    </defs>
    <rect x="2" y="2" width="44" height="44" rx="13.5" fill="url(#lkt-bg)" />
    <path d="M10 27.5 L37 13 L28.5 30 L24 25.5 L17.5 29z" fill="#fff" />
    <path d="M24 25.5 L24 34 L28.5 30" fill="#e2ff70" />
  </svg>
);

const LakeyAviaLogo = () => (
  <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" fill="none" aria-hidden="true">
    <defs>
      <linearGradient id="lka-bg" x1="4" y1="4" x2="44" y2="44" gradientUnits="userSpaceOnUse">
        <stop stopColor="#38bdf8" />
        <stop offset="0.55" stopColor="#2563eb" />
        <stop offset="1" stopColor="#1e3a8a" />
      </linearGradient>
    </defs>
    <rect x="2" y="2" width="44" height="44" rx="13.5" fill="url(#lka-bg)" />
    <path d="M9 26.5 L38 12 L27 34 L22.5 27.5 L14.5 31z" fill="#fff" />
    <path d="M22.5 27.5 L22.5 35.5 L27 34" fill="#e2ff70" />
    <path d="M31 8.5c.85 2.75 1.4 3.3 4.15 4.15-2.75.85-3.3 1.4-4.15 4.15-.85-2.75-1.4-3.3-4.15-4.15 2.75-.85 3.3-1.4 4.15-4.15z" fill="#e2ff70" />
  </svg>
);

const LakeyWemLogo = () => (
  <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" fill="none" aria-hidden="true">
    <rect x="2" y="2" width="44" height="44" rx="13.5" fill="#12314a" />
    <path d="M9 33h30M13 28l7-7 5 4 10-11" stroke="#67e8f9" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M30 14h5v5" stroke="#e2ff70" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M13 37h22" stroke="#fff" strokeOpacity=".55" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const LakeyLanguageLogo = () => (
  <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" fill="none" aria-hidden="true">
    <rect x="2" y="2" width="44" height="44" rx="13.5" fill="#443477" />
    <path d="M24 15c-4-3-8-3-13-1v19c5-2 9-2 13 1m0-19c4-3 8-3 13-1v19c-5-2-9-2-13 1m0-19v19" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M16 20h4m12 0h-4" stroke="#e2ff70" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const LakeyLocalLogo = ({ label = 'L' }) => (
  <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <rect x="2" y="2" width="44" height="44" rx="13.5" fill="#28344a" />
    <text x="24" y="32" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="23" fontWeight="700" fill="#e2ff70">{label}</text>
  </svg>
);

const peopletag = {
  name: 'Peopletag',
  url: 'https://peopletag-demo-1.web.app/',
  Logo: PeopletagLogo,
  accent: 'accent-peopletag',
  deprecated: true,
  description: 'Peopletag is a social discovery platform that helps you find people through tags — the technologies, topics, and communities they actually care about. A searchable map of who-knows-what, built and curated by the people on it.'
};

const aidrivex = {
  name: 'Aidrivex',
  url: 'https://aidrivex.web.app/',
  Logo: AidrivexLogo,
  accent: 'accent-aidrivex',
  description: 'Aidrivex is the AI driven lab platform — the place where AI Driven Labs members log in to create, customize and deploy conversational AI agents. Build a profile, attach knowledge documents, pick a model, and ship an embeddable applet to any website in minutes.'
};

const lakey = {
  name: 'LakeyApp',
  url: 'https://lakey.app/',
  Logo: LakeyLogo,
  accent: 'accent-lakey',
  description: 'LakeyApp is an AI-powered rental search for Serbia. Describe what you need in plain language — budget, district, size, pets — and Lakey scans listings across sources, filters out the noise and scams, and hands you only the places actually worth a viewing.'
};

const lakeyFit = {
  name: 'LakeyFit',
  url: 'https://lakeyfit.web.app/',
  Logo: LakeyFitLogo,
  accent: 'accent-lakeyfit',
  description: 'LakeyFit is an AI coach in your pocket. It builds a training plan around your goals, equipment and schedule, adapts week to week as you log workouts, and explains every exercise — no gym membership or personal trainer required.'
};

const lakeyLook = {
  name: 'LakeyLook',
  url: 'https://lakeylook.web.app/',
  Logo: LakeyLookLogo,
  accent: 'accent-lakeylook',
  description: 'LakeyLook gives you an honest AI-powered outfit review from a photo. It scores the look across style, fit, color, expressiveness, appropriateness and details, then explains exactly what works and what could be improved.'
};

const lakeyNoWords = {
  name: 'LakeyNoWords',
  url: 'https://lakeynowords.web.app/',
  Logo: LakeyNoWordsLogo,
  accent: 'accent-lakeynowords',
  description: 'LakeyNoWords is an offline collection of ideas that language struggles to name: 434 words across 85 languages and 86 nameless phenomena, with daily discovery, search, favorites and a quiz.'
};

const fujoAi = {
  name: 'fujoAI',
  url: 'https://fjoai.web.app/',
  Logo: FujoAiLogo,
  accent: 'accent-fujoai',
  description: 'fujoAI — fast job offer AI search. Point it at your profile and it hunts openings across job boards in parallel, ranks them by real fit instead of keyword overlap, and drafts a tailored application for the ones worth your time.'
};

const lakeyTravel = {
  name: 'LakeyTravel',
  url: 'https://lakeytravel.web.app/',
  Logo: LakeyTravelLogo,
  accent: 'accent-lakeytravel',
  description: 'LakeyTravel is an AI travel-pack agency hunter. Tell it where and when you want to go, and it searches agency packages across the market, compares what is actually included, and surfaces the best-value trips for your dates and budget.'
};

const lakeyAvia = {
  name: 'LakeyAvia',
  url: 'https://lakeyavia.web.app/',
  Logo: LakeyAviaLogo,
  accent: 'accent-lakeyavia',
  description: 'LakeyAvia is a flight-search aggregator that watches your routes and dates around the clock and pings you on Telegram the moment a fare matching your criteria shows up — no more manually refreshing search engines.'
};

const lakeyWem = {
  name: 'Lakey WEM',
  url: 'https://lakeywem.web.app/',
  Logo: LakeyWemLogo,
  accent: 'accent-lakeywem',
  description: 'Lakey WEM monitors the global economy, bringing key indicators and market signals together so you can follow what is changing around the world.'
};

const lakeyLanguage = {
  name: 'LakeyLanguage',
  url: 'https://lakeylanguage.web.app/',
  Logo: LakeyLanguageLogo,
  accent: 'accent-lakeylanguage',
  description: 'LakeyLanguage helps you learn languages through audiobooks, combining listening practice with stories you can enjoy at your own pace.'
};

const lakeyBF = {
  name: 'LakeyBF',
  Logo: () => <LakeyLocalLogo label="BF" />,
  accent: 'accent-lakeybf',
  status: 'Local project',
  description: 'Control and automate Android devices from your computer.'
};

const lakeyFfbot = {
  name: 'Lakey_ffbot',
  Logo: () => <LakeyLocalLogo label="ƒ" />,
  accent: 'accent-lakeyffbot',
  status: 'Local project',
  description: 'A Pump.fun and FOMO.family trading bot with paper trading, DCA, and trailing exits.'
};

const arcFinanceHub = [
  {
    name: 'Arc Finance Hub',
    url: 'https://arcfinhub.xyz/',
    Logo: ArcFinanceHubLogo,
    accent: 'accent-arcfinhub',
    description: 'Arc Finance Hub is one address for every USDC-native primitive on Arc: payment links, bill splits, micro-payments, instant checkout and programmable streams. Connect once — Arc Finance Hub remembers your wallet, and shows your activity across every Arc app you have ever used.'
  },
  {
    name: 'Fastysend',
    url: 'https://fastysend.web.app/',
    Logo: FastysendLogo,
    accent: 'accent-fastysend',
    description: 'Fastysend lets you send USDC in seconds on Arc, Circle’s stablecoin-native L1. No gas tokens to juggle, no setup friction — just type an amount, confirm, and the payment lands with sub-second finality.'
  },
  {
    name: 'Microsub',
    url: 'https://microsub.web.app/',
    Logo: MicrosubLogo,
    accent: 'accent-microsub',
    description: 'Microsub brings micro-payments to content: unlock individual articles for cents in USDC on Arc, with a single-tap wallet confirmation and no email signup. Publishers embed; readers deposit once and pay per read.'
  },
  {
    name: 'ArcSplitIt',
    url: 'https://arcsplitit.web.app/',
    Logo: ArcSplitItLogo,
    accent: 'accent-arcsplitit',
    description: 'ArcSplitIt makes splitting bills effortless on Arc. Create a group, add expenses in USDC, and settle up with sub-second on-chain transfers — no gas tokens, no IOUs, just clean settlements between friends.'
  },
  {
    name: 'ArcYield',
    url: 'https://arcyield.web.app/',
    Logo: ArcYieldLogo,
    accent: 'accent-arcyield',
    description: 'Payroll, allowances, vesting — schedule once, USDC flows continuously on Arc. Recipients claim what they\'ve earned anytime. No middleman, no custodian, no second signature.'
  },
  {
    name: 'ICX',
    url: 'https://icx.web.app/#/',
    Logo: IcxLogo,
    accent: 'accent-icx',
    description: 'Drop the icx button anywhere on your site to accept USDC on Arc. Wallet-native, gasless UX for returning customers, settlement in seconds.'
  },
  {
    name: 'Arc Escrow',
    url: 'https://arcescrow.web.app/',
    Logo: ArcEscrowLogo,
    accent: 'accent-arcescrow',
    description: 'Arc Escrow is a trustless USDC escrow on Arc. Lock funds on create, release on 2-of-N approval, refund on timeout — perfect for freelance work, marketplace trades, rentals and custom deals. No middleman, just code.'
  },
  {
    name: 'Arc Payroll',
    url: 'https://arcpayroll.web.app/',
    Logo: ArcPayrollLogo,
    accent: 'accent-arcpayroll',
    description: 'Arc Payroll sends batch USDC payments on Arc — one transaction, N paychecks. Paste a list of addresses and amounts, dedupe duplicates, and settle every recipient in a single on-chain call. Built for payroll runs, airdrops, contractor pay and any time you need to pay many wallets at once.'
  },
  {
    name: 'Arc AutoPay',
    url: 'https://arcautopay.web.app/',
    Logo: ArcAutoPayLogo,
    accent: 'accent-arcautopay',
    description: 'Recurring USDC transfers on a calendar cadence — rent on the 1st, allowance every Friday. Pre-approve a spending cap, a thin puller contract executes on schedule, cancel anytime in one tx. Direct-debit ergonomics with on-chain custody.'
  }
];

const groups = [
  { id: 'lakey-projects', title: 'Lakey Projects', items: [lakey, lakeyFit, lakeyLook, lakeyNoWords, lakeyTravel, lakeyAvia, lakeyLanguage, lakeyWem, lakeyBF, lakeyFfbot] },
  { id: 'other', title: 'Projects', items: [peopletag, fujoAi, aidrivex] },
  { id: 'arc-finance-hub', title: 'Arc Finance Hub', items: arcFinanceHub }
];

function Projects() {
  return (
    <div className="projects-container">
      <div className="projects-header">
        <h1 className="projects-title">Our Projects</h1>
        <div className="projects-intro">
          <p><strong>AI Driven Labs is a team of dreamers.</strong> Our mission is to democratize AI and Web3 technology by providing intuitive tools that allow users to&nbsp;harness the power of conversational AI and Blockchain for their specific needs. Whether you're looking to&nbsp;enhance customer support, create&nbsp;interactive website assistants, or build specialized AI agents for your business, AI Driven Labs provides the solution.<br />We empower individuals and&nbsp;businesses to create, customize, and deploy AI agents without requiring any technical expertise.</p>
          <p><strong>We make artificial intelligence accessible to everyone.</strong></p>
        </div>
      </div>

      {groups.map((group, gi) => {
        let cardIndex = 0;
        for (let k = 0; k < gi; k++) cardIndex += groups[k].items.length;
        return (
          <section key={group.id} className={`project-group group-${group.id}`}>
            {group.title && <h2 className="group-title">{group.title}</h2>}
            <div className="projects-grid">
              {group.items.map((p, i) => {
                const Logo = p.Logo;
                const delay = (cardIndex + i) * 120;
                const Card = p.url ? 'a' : 'div';
                const linkProps = p.url
                  ? { href: p.url, target: '_blank', rel: 'noopener noreferrer' }
                  : {};
                return (
                  <Card
                    key={p.name}
                    {...linkProps}
                    className={`project-card ${p.accent}${p.url ? '' : ' project-card-soon'}`}
                    style={{ animationDelay: `${delay}ms` }}
                  >
                    <div className="project-logo-wrap">
                      <div className="project-logo">
                        <Logo />
                      </div>
                    </div>
                    <h3 className="project-name">{p.name}</h3>
                    <p className="project-description">{p.description}</p>
                    <div className="project-card-footer">
                      <span className="project-link-text">
                      {p.url
                        ? p.url.replace(/^https?:\/\//, '').replace(/\/$/, '')
                        : (p.status || 'coming soon')}
                      {p.url && <span className="project-arrow">&rarr;</span>}
                      </span>
                      {p.deprecated && <span className="project-deprecated">(deprecated)</span>}
                    </div>
                  </Card>
                );
              })}
            </div>
          </section>
        );
      })}
    </div>
  );
}

export default Projects;
